<dx-scroll-view direction="horizontal">
	<dx-menu #menu [items]="dataSource" selectionMode="none">

		<a role="button" [routerLink]="routerLink(item)" *dxTemplate="let item of 'itemTemplateHome'">
			<i class="fa-fw fa-lg" [ngClass]="item.icon"></i>
		</a>

		<a role="button" *dxTemplate="let item of 'itemTemplateParent'" [ngClass]="{'dx-menu-item-selected': item.selected || isAnyChildItemActive(item?.items)}">
			@switch(item.iconType){
				@case('fa'){
					<i class="dx-icon fa-fw fa-lg" [ngClass]="item.icon"></i>
				}
				@case('bi'){
					<i class="dx-icon bi" [ngClass]="item.icon"></i>
				}
			}

			<span class="dx-menu-item-text" [ngClass]="{'ms-1' : item.iconType != 'txt'}">{{(item.title || item.label) | translate}}</span>
			@if(item.items?.length > 0){
				<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>
			}
		</a>

		<a role="button" [routerLink]="routerLink(item)" *dxTemplate="let item of 'itemTemplateChild'" [ngClass]="{'dx-menu-item-selected': isItemActive(item)}">
			@switch(item.iconType){
				@case('fa'){
					<i class="dx-icon fa-fw fa-lg" [ngClass]="item.icon"></i>
				}
				@case('bi'){
					<i class="dx-icon bi" [ngClass]="item.icon"></i>
				}
			}

			<span class="dx-menu-item-text" [ngClass]="{'ms-1' : item.iconType != 'txt'}">{{(item.title || item.label) | translate}}</span>
		</a>
	</dx-menu>
</dx-scroll-view>
